import type { PropsWithChildren } from 'react';
import { BrandWordmark } from '@/design-system/composite/BrandWordmark';

/** Shared Tailwind for the auth forms (login / accept-invite / reset). */
export const authInputClass =
  'rounded-xl border border-border-default px-3 py-2 text-base outline-none focus:border-secondary-emphasized focus:ring-2 focus:ring-secondary-main';
export const authButtonClass =
  'mt-2 rounded-xl bg-gradient-to-r from-secondary-focal to-primary-focal px-4 py-2.5 font-semibold text-white transition hover:opacity-90 disabled:opacity-60';

/** Centered branded card used by every unauthenticated auth screen. */
export const AuthCard = ({ children }: PropsWithChildren) => (
  <div className="flex min-h-dvh items-center justify-center bg-gradient-to-br from-secondary-subtle via-primary-subtle to-secondary-subtle p-4">
    <div className="w-full max-w-sm rounded-3xl bg-white p-8 shadow-xl">
      {/* Full-width so the brand chip lines up edge-to-edge with the form's
          inputs and submit button — same width, same side insets. */}
      <div className="mb-6">
        <BrandWordmark className="w-full justify-center" />
      </div>
      {children}
    </div>
  </div>
);
